export const currencyFormat = (value, currency = "GHS") => {
  return new Intl.NumberFormat("en-GB", {
    currency,
    style: "currency",
    minimumFractionDigits: 2
  }).format(value);
};
